module.exports = __webpack_public_path__ + "static/img/ydyj.a5879dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ydyj.png
// module id = fz7b
// module chunks = 1